// extracted by mini-css-extract-plugin
export default {"btn":"Performance_btn__0mL1i"};